import React from 'react';
import { Helmet } from 'react-helmet';
import '../assets/css/PrivacyPolicy.css';

function PrivacyPolicy() {
    return (
        <>
            <Helmet>
                <title>Secouristes Français Croix Blanche | Données personnelles</title>
                <link rel="canonical" href="https://croixblanche-42.org/donnees-personnelles" />
            </Helmet>
        <div className="privacy-container my-5">
            <h1 className="privacy-section-title">Politique de protection des données personnelles</h1>
            <p>
                <strong>Propriétaire et responsable du traitement :</strong> Fédération des Secouristes Français Croix Blanche de la Loire – 13 Rue de la Glacière - 42120 Le Coteau.
            </p>
            <p>
                <strong>Courriel de contact :</strong> <a href="mailto:webmaster@croixblanche-42.org">webmaster@croixblanche-42.org</a>
            </p>

            <h3 className="mt-4">Type de données collectées</h3>
            <p>
                Ce site collecte les types de données personnelles suivants : prénom, nom de famille, numéro de téléphone, adresse, adresse électronique, code postal, Cookie et Données d’utilisation.
            </p>
            <p>
                Toutes les données demandées par ce site sont obligatoires et leur absence peut rendre impossible la fourniture des services ou renseignements demandés.
            </p>
            <p>
                Les utilisateurs sont responsables des données personnelles de tiers obtenues, publiées ou communiquées via ce site et confirment qu’ils obtiennent le consentement nécessaire pour fournir ces données au propriétaire.
            </p>

            <h3 className="mt-4">Mode et lieu de traitement des données</h3>
            <p>
                Les données sont traitées au siège du propriétaire et dans les lieux où sont situés les parties responsables du traitement.
            </p>
            <p>
                Le propriétaire prend des mesures de sécurité appropriées pour empêcher l'accès non autorisé, la divulgation, la modification ou la destruction des données personnelles.
            </p>

            <h3 className="mt-4">Base juridique du traitement</h3>
            <ul>
                <li>Les utilisateurs ont donné leur consentement pour une ou plusieurs finalités spécifiques.</li>
                <li>Le traitement est nécessaire pour l'exécution d'un contrat avec l'utilisateur.</li>
                <li>Le traitement est requis pour se conformer à une obligation légale.</li>
                <li>Le traitement est nécessaire pour l'intérêt légitime poursuivi par le propriétaire.</li>
            </ul>

            <h3 className="mt-4">Lieu de traitement des données</h3>
            <p>
                Selon la localisation de l'utilisateur, les transferts de données peuvent impliquer un transfert vers un pays tiers hors de l'Union européenne. Si un tel transfert a lieu, les utilisateurs peuvent demander des détails auprès du propriétaire.
            </p>

            <h3 className="mt-4">Durée de conservation</h3>
            <p>
                Les données personnelles sont conservées aussi longtemps que nécessaire pour la finalité pour laquelle elles ont été collectées. Une fois la période de conservation expirée, les données sont supprimées.
            </p>

            <h3 className="mt-4">Finalités du traitement</h3>
            <p>
                Les données sont collectées pour permettre au propriétaire de fournir ses services, notamment pour :
            </p>
            <ul>
                <li>Contacter l'utilisateur</li>
                <li>Analyser les données de navigation</li>
                <li>Interaction avec les réseaux sociaux et les plateformes externes</li>
                <li>Gestion de la base de données des utilisateurs</li>
            </ul>

            <h3 className="mt-4">Droits des utilisateurs</h3>
            <p>Les utilisateurs peuvent exercer les droits suivants :</p>
            <ul>
                <li>Retirer leur consentement à tout moment</li>
                <li>S'opposer au traitement de leurs données</li>
                <li>Accéder à leurs données</li>
                <li>Rectifier leurs données</li>
                <li>Limiter le traitement de leurs données</li>
                <li>Faire supprimer leurs données</li>
                <li>Transférer leurs données vers un autre responsable</li>
                <li>Déposer une plainte auprès d'une autorité compétente (ex. : CNIL)</li>
            </ul>

            <h3 className="mt-4">Exercice des droits</h3>
            <p>
                Toute demande peut être adressée par email à <a href="mailto:webmaster@croixblanche-42.org">webmaster@croixblanche-42.org</a>. Les demandes seront traitées dans un délai d'un mois.
            </p>

            <h3 className="mt-4">Modifications de la politique de confidentialité</h3>
            <p>
                Cette politique de confidentialité peut être modifiée à tout moment. Les utilisateurs sont invités à consulter cette page régulièrement. La dernière mise à jour a été effectuée le 10 janvier 2025.
            </p>
        </div>
        </>
    );
}

export default PrivacyPolicy;
